
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import { Action } from "vuex-class";
import { PaymentTypeEnum } from "@/constants/enum.constant";
import toast from "@/functions/toast.function";
import { AxiosResponse } from "axios";
import { isPhone } from "@/functions/global.function";

@Component({
  components: {
    AppLayout,
  },
  filters,
})
export default class Checkout extends Vue {
  @Action("buy", { namespace: "payment" })
  private buy: any;

  private types = [
    {
      id: PaymentTypeEnum.OVO,
      name: "OVO",
      image: require("@/assets/images/payment-ovo.png"),
      required: "phone",
    },
    {
      id: PaymentTypeEnum.DANA,
      name: "Dana",
      image: require("@/assets/images/payment-dana.png"),
      required: false,
    },
    {
      id: PaymentTypeEnum.QRIS,
      name: "QRIS",
      image: require("@/assets/images/payment-qris.png"),
      required: false,
    },
  ];
  private paymentType = 0;
  private phone = "+62";
  private courseId = 0;
  private bundleCourseId = 0;
  private price: any = 0;
  private offerPrice: any = 0;
  private codePrice: any = 0;
  private name = "";
  private code: any = null;

  @Watch("$route.query")
  private onQuery() {
    this.setParams();
  }

  private get discountPrice() {
    if (this.offerPrice) return this.offerPrice - this.codePrice;
    else return this.price - this.codePrice;
  }

  private get finalPrice() {
    if (this.codePrice) return this.codePrice;
    else if (this.offerPrice) return this.offerPrice;
    else return this.price;
  }

  private created() {
    this.setParams();
    if (!this.courseId && !this.bundleCourseId) {
      this.$router.push({
        name: "home",
      });
    }
  }

  private setParams() {
    this.courseId = parseInt(this.$route.params.bundle_course_id);
    this.bundleCourseId = parseInt(this.$route.params.course_id); 
    this.price = parseInt(this.$route.params.price);
    this.offerPrice = parseInt(this.$route.params.offer_price);
    this.codePrice = parseInt(this.$route.params.code_price);
    this.name = this.$route.params.name;
    this.code = this.$route.params.code;
  }

  private onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode !== 43) {
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  }

  private checkout() {
    if (!this.paymentType) {
      toast.warning("Please select payment type.");
      return false;
    }
    if (this.paymentType === PaymentTypeEnum.OVO) {
      if (!isPhone(this.phone)) {
        toast.warning("Please input correct phone number.");
        return false;
      }
    }
    this.buy({
      params: {
        bundle_course_id: this.courseId,
        course_id: this.bundleCourseId,
        payment_type: this.paymentType,
        phone: this.phone,
        partner_code_id: this.code?.id,
      },
      success: (response: AxiosResponse) => {
        try {
          const urls = JSON.parse(response.data.data.url);
          const redirect =
            urls?.desktop_web_checkout_url || urls?.mobile_web_checkout_url;
          if (redirect) {
            switch (this.paymentType) {
              case PaymentTypeEnum.DANA:
                window.open(redirect, "_blank");
                break;
              default:
                break;
            }
          }
        } catch (e) {
          console.error("Failed to redirect.", e);
        }

        this.$router.push({
          name: "payment",
          params: {
            invoice: response.data.data.invoice_number,
          },
        });
      },
    });
  }
}
